// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"caa35472","389":"ccaf0e80","959":"0fe9d1b2","990":"b8acf407"}[chunkId] + ".chunk.css";
};